
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.429 13.429a.858.858 0 00-.858.857v5.143a.857.857 0 01-.857.857H3.571a.857.857 0 01-.857-.857v-5.143a.857.857 0 10-1.714 0v5.143A2.57 2.57 0 003.571 22h17.143a2.571 2.571 0 002.572-2.571v-5.143a.857.857 0 00-.857-.857z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M7.272 7.75a.857.857 0 001.19 0l2.825-2.823v12.788a.857.857 0 001.715 0V4.927l2.822 2.822a.857.857 0 001.212-1.212L12.75 2.252a.857.857 0 00-1.212-.002L7.25 6.537a.857.857 0 00.02 1.212z","fill-rule":"nonzero"}})])
          )
        }
      }
    